import { Plan } from '../plan';

export class Faim extends Plan {
    public static readonly PLAN_TYPE = 'faim';

    public isPlanFaim() {
        return true;
    }
}
